import {IHttpService} from "angular";
import {NewTradingAlertDefinition, TradingAlert, TradingAlertDefinition} from "../models/alert/TradingAlert";

export class TradingAlertService {

    public static id = "tradingAlertService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {
        this.init();
    }

    private init() {
    }

    public async createTradingAlert(alert: NewTradingAlertDefinition): Promise<void> {
        const url = `/tradefloor/api/trading-alerts`;
        await this.$http.post(url, alert);
    }

    public async alerts(): Promise<Array<TradingAlert>> {
        const url = `/tradefloor/api/trading-alerts`;
        const response = await this.$http.get<Array<TradingAlert>>(url);
        return response.data!;
    }

    public async cancelTradingAlert(id: number): Promise<void> {
        const url = `/tradefloor/api/trading-alerts/cancel/${id}`;
        await this.$http.post(url, null);
    }

    public async acknowledgeTradingAlert(id: number): Promise<void> {
        const url = `/tradefloor/api/trading-alerts/acknowledge/${id}`;
        await this.$http.post(url, null);
    }

    public async update(id: number, updated: TradingAlertDefinition) {
        const url = `/tradefloor/api/trading-alerts/${id}`;
        await this.$http.put(url, updated);
    }
}
